module.exports = __webpack_public_path__ + "static/media/dp1.8cf5a4ca.png";